<template>
<div>
  <div class="login-container">
    <v-form ref="loginForm" v-model="loginForm" lazy-validation>
      <v-text-field
        :label="lang == 'en' ? 'Username' : 'Korisničko ime'"
        v-model="user.username"
        @keyup.enter="login()"
        :rules="rules.required"
        outlined
        dense
      ></v-text-field>
      <v-text-field
        :label="lang == 'en' ? 'Password' : 'Lozinka'"
        type="password"
        v-model="user.password"
        @keyup.enter="login()"
        :rules="rules.required"
        outlined
        dense
      ></v-text-field>
      <v-btn depressed block class="text--white teal darken-2" @click="login()">
        {{lang == 'en' ? 'LOGIN' : 'PRIJAVA'}}
      </v-btn>
    </v-form>
  </div>
  </div>
</template>

<script>
import { mapGetters, mapState } from "vuex";
export default {
  name: "Login",
  data: () => ({
    loginForm: false,
    user: {
      username: '',
      password: ''
    }
  }),
  computed: {
    ...mapState(["snackbar", "lang", "languageItems"]),
    ...mapGetters(["languageItemsList", "rules"])
  },
  methods: {
    login() {
      if (this.$refs.loginForm.validate()) {
        this.$store.dispatch("login", {username: this.user.username, password: this.user.password})
      } else {
          this.snackbar.value = true;
          this.snackbar.color = 'red';
          this.snackbar.text = this.lang == 'en' ? 'Wrong username or passwrod' : 'Pogresno korisničko ime ili lozinka';
      }
    }
  }
};
</script>

<style lang="scss">
.login-container {
  max-width: 400px;
  width: 100%;
  padding: 50px 20px;
  border-radius: 4px;
  margin: 100px auto;
  position: absolute;
  top: 190px;
  left: 50%;
  transform: translate(-50%, -50%);
  background: rgba(55,55,55,.8);
}
.logo-login {
  max-width: 50px;
}

@media(max-width: 768px) {
  .login-container {
    width: 90%;
  }
}
</style>